/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespTradeOnApprovalCoachmarkLoader_user = {
    readonly serviceId: string | null;
    readonly " $refType": "PdpRespTradeOnApprovalCoachmarkLoader_user";
};
export type PdpRespTradeOnApprovalCoachmarkLoader_user$data = PdpRespTradeOnApprovalCoachmarkLoader_user;
export type PdpRespTradeOnApprovalCoachmarkLoader_user$key = {
    readonly " $data"?: PdpRespTradeOnApprovalCoachmarkLoader_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespTradeOnApprovalCoachmarkLoader_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespTradeOnApprovalCoachmarkLoader_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '520265f1673aea4fb5900e1e20a9d5d9';
export default node;
